@if (groupedBookings && hasVisibleGroups()) {
  <mat-accordion [multi]="true" [hideToggle]="printGroups" [class.driver-mode]="driverMode"
    >
    @for (group of groupedBookings; track group) {
      @if (!(driverMode && (isGroupCallCustomers(group) || (isGroupDeparture(group) && isNoShowsCustomers(group))))) {
        <mat-expansion-panel
          class="{{isGroupCallCustomers(group) || isNoShowsCustomers(group) ? 'panel-margin-bottom':''}}  {{isGroupPickedUpCustomers(group) || isGroupDroppedOffCustomers(group) ? 'hide-on-print panel-margin-bottom':''}}"
          (opened)="handleExpansionPanelState(group, true)" (closed)="handleExpansionPanelState(group, false)"
          [expanded]="printGroups ? true : isExpansionPanelOpen(group)">
          <mat-expansion-panel-header
            [ngClass]="{ 'compact-header': driverMode && (isGroupPickedUpCustomers(group) || isGroupDroppedOffCustomers(group)) }">
            <mat-panel-title>
              @if (isGroupArrival(group) && !isGroupCallCustomers(group) && !isGroupPickedUpCustomers(group)) {
                <span class="group-booking-info flight-number"
                  matTooltip="{{checkPlaneHasLanded(group) ? 'Planet har landat' : null}}">
                  @if (checkPlaneHasLanded(group) && $any(group).terminal) {
                    <span
                      class="plane-has-landed fw-600">{{$any(group).terminal}}
                    </span>
                  }
                  @if (!checkPlaneHasLanded(group) || checkPlaneHasLanded(group) && !$any(group).terminal) {
                    <mat-icon
                      class="{{checkPlaneHasLanded(group) ? 'plane-has-landed' : 'rotate-icon'}}">{{checkPlaneHasLanded(group) ?
                      'flight_land' : 'airplanemode_active'}}
                    </mat-icon>
                  }
                  {{ $any(group).flightNumber }}
                  <!-- Time not in driver mode -->
                  @if (!driverMode) {
                    <span class="time">
                      {{ formatTime($any(group).arrivalDate) }}
                    </span>
                  }
                </span>
              }
              @if (isGroupArrival(group) && isGroupCallCustomers(group) || isGroupDeparture(group) && isNoShowsCustomers(group)) {
                <span class="group-booking-info flight-number"
                  >
                  <mat-icon class="call-customer">phone</mat-icon>
                  Ringkunder
                </span>
              }
              @if (isGroupDroppedOffCustomers(group) || isGroupPickedUpCustomers(group)) {
                <span class="group-booking-info {{isGroupPickedUpCustomers(group) ? 'flight-number' : 'time'}}"
                  >
                  <mat-icon class="call-customer">checklist_rtl</mat-icon>
                  {{isGroupPickedUpCustomers(group) ? 'Hämtade' : 'Lämnade'}}
                </span>
              }
              @if (!isGroupArrival(group) && !isGroupDroppedOffCustomers(group) && !isNoShowsCustomers(group)) {
                <span class="group-booking-info time"
                  >
                  <mat-icon> directions_car</mat-icon>
                  {{ formatTime(group.departureDate) }}
                </span>
              }
              @if (!driverMode) {
                <span class="group-booking-info">
                  <mat-icon>people</mat-icon>{{displayPassengerStatus(group)}}
                </span>
              }
              @if (isGroupArrival(group) && !isGroupCallCustomers(group) && !isGroupPickedUpCustomers(group)) {
                <span
                  class="group-booking-info travel-home-from"
                  matTooltip="{{$any(group).departureAirport?.length > 33 ? $any(group).departureAirport : undefined}}"><!-- Only show tooltip when airport name is longer than 33 char ~350px wide -->
                  {{$any(group).departureAirport}}
                </span>
              }
              <!-- Status icons -->
              @if (!driverMode && !isGroupPickedUpCustomers(group) && !isGroupDroppedOffCustomers(group)) {
                <div class="info-icons"
                  >
                  @if (!isGroupPickedUpCustomers(group)) {
                    <span class="booking-info-icon">
                      <mat-icon class="{{checkIfSomeInGroupWantCarSeat(group) ? 'booking-icon-active' : null}}"
                        matTooltip="{{checkIfSomeInGroupWantCarSeat(group) ? 'Minst en bokning önskar barnsäkerhetstillbehör' : 'Inget behov av barnsäkerhetstillbehör'}}">
                        child_care
                      </mat-icon>
                    </span>
                  }
                  <span class="booking-info-icon">
                    <mat-icon class="{{checkIfSomeInGroupHasDemand(group) ? 'booking-icon-active' : null}}"
                    matTooltip="{{checkIfSomeInGroupHasDemand(group) ? 'Minst en bokning med KRAV' : 'Inga bokningar med KRAV'}}">credit_card</mat-icon>
                  </span>
                  <span class="booking-info-icon">
                    <mat-icon class="{{checkIfSomeInGroupInGarage(group) ? 'booking-icon-active garage' : 'garage'}}"
                    matTooltip="{{checkIfSomeInGroupInGarage(group) ? 'Minst en bil i garage' : 'Ingen bil i garage'}}">garage</mat-icon>
                  </span>
                  <span class="booking-info-icon">
                    <mat-icon
                      class="{{checkIfSomeInGroupHasCarWash(group) || checkIfSomeInGroupHasCharge(group) || checkIfSomeInGroupHasTireRepair(group) ? 'booking-icon-active' : null}}"
                matTooltip="{{checkIfSomeInGroupHasCarWash(group) || checkIfSomeInGroupHasCharge(group) || checkIfSomeInGroupHasTireRepair(group) ?
               'Minst en bil med bokad tvätt, laddning och/eller däckverkstad' : 'Ingen bil med bokad tvätt, laddning eller däckverkstad'}}">
                      local_car_wash
                    </mat-icon>
                  </span>
                  @if (isGroupArrival(group) && !isGroupPickedUpCustomers(group)) {
                    <span class="booking-info-icon">
                      <mat-icon class="{{checkIfSomeInGroupCarryOnOnly(group) ? 'booking-icon-active' : null}}"
                      matTooltip="{{checkIfSomeInGroupCarryOnOnly(group) ? 'Minst en bokning med bara handbagage' : 'Bara bokningar med incheckat bagage'}}">business_center</mat-icon>
                    </span>
                  }
                  @if (isGroupArrival(group) && !isGroupPickedUpCustomers(group)) {
                    <span class="booking-info-icon">
                      <mat-icon
                        class="{{$any(group).firstBagDate || $any(group).lastBagDate ? 'booking-icon-active first_bag' : 'first_bag'}}"
                      matTooltip="{{$any(group).lastBagDate ? 'Sista bagage på band' : $any(group).firstBagDate ? 'Första bagage på band' : 'Bandet kör inte'}}">work</mat-icon>
                    </span>
                  }
                  @if (!isGroupPickedUpCustomers(group)) {
                    <span class="booking-info-icon">
                      <mat-icon class="{{checkIfSomeInGroupHasComment(group) ? 'booking-icon-active' : null}}"
                      matTooltip="{{checkIfSomeInGroupHasComment(group) ? 'Minst en bokning med en kommentar' : 'Inga kommentarer'}}">chat_bubble</mat-icon>
                    </span>
                  }
                </div>
              }
              <!-- Time driver mode -->
              @if (driverMode) {
                <span class="time-driver-mode">
                  {{ formatTime($any(group).arrivalDate) }}
                </span>
              }
              @if (driverMode && !isGroupPickedUpCustomers(group) && !isGroupDroppedOffCustomers(group)) {
                <div class="info-icons driver-icons"
                  >
                  @if (isGroupArrival(group) && !isGroupPickedUpCustomers(group)) {
                    <span class="booking-info-icon first-bag-icon"
                      >
                      <mat-icon
                        class="{{$any(group).firstBagDate || $any(group).lastBagDate ? 'booking-icon-active first_bag' : 'first_bag'}}"
                      matTooltip="{{$any(group).lastBagDate ? 'Sista bagage på band' : $any(group).firstBagDate ? 'Första bagage på band' : 'Bandet kör inte'}}">work</mat-icon>
                    </span>
                  }
                  <div class="status-icons-group" [ngClass]="{departure: isGroupDeparture(group)}">
                    @if (!isGroupPickedUpCustomers(group)) {
                      <span class="booking-info-icon">
                        <mat-icon class="{{checkIfSomeInGroupWantCarSeat(group) ? 'booking-icon-active' : null}}"
                          matTooltip="{{checkIfSomeInGroupWantCarSeat(group) ? 'Minst en bokning önskar barnsäkerhetstillbehör' : 'Inget behov av barnsäkerhetstillbehör'}}">
                          child_care
                        </mat-icon>
                      </span>
                    }
                    <span class="booking-info-icon">
                      <mat-icon class="{{checkIfSomeInGroupHasDemand(group) ? 'booking-icon-active' : null}}"
                      matTooltip="{{checkIfSomeInGroupHasDemand(group) ? 'Minst en bokning med KRAV' : 'Inga bokningar med KRAV'}}">credit_card</mat-icon>
                    </span>
                    @if (isGroupArrival(group) && !isGroupPickedUpCustomers(group)) {
                      <span class="booking-info-icon">
                        <mat-icon class="{{checkIfSomeInGroupCarryOnOnly(group) ? 'booking-icon-active' : null}}"
                        matTooltip="{{checkIfSomeInGroupCarryOnOnly(group) ? 'Minst en bokning med bara handbagage' : 'Bara bokningar med incheckat bagage'}}">business_center</mat-icon>
                      </span>
                    }
                    @if (isGroupDeparture(group)) {
                      <span class="booking-info-icon return-flight-icon">
                        <mat-icon
                          class="{{checkIfSomeInGroupMissingReturnFlightNumber(group) ? 'booking-icon-active' : null}}"
                        matTooltip="{{checkIfSomeInGroupMissingReturnFlightNumber(group) ? 'Minst en bokning saknar flightnummer för hemresa' : 'Alla bokningar har flightnummer för hemresa'}}">flight</mat-icon>
                      </span>
                    }
                    <!-- Key icon only in driver mode -->
                    @if ((!isGroupArrival(group) || !isGroupDroppedOffCustomers(group)) && !isNoShowsCustomers(group)) {
                      <span class="booking-info-icon"
                        >
                        <mat-icon class="{{checkIfSomeInGroupRequiresKey(group) ? 'booking-icon-active' : null}}"
                        matTooltip="{{checkIfSomeInGroupRequiresKey(group) ? 'Nyckel krävs (garage/tvätt/verkstad)' : 'Ingen nyckel krävs'}}">vpn_key</mat-icon>
                      </span>
                    }
                    @if (!isGroupPickedUpCustomers(group)) {
                      <span class="booking-info-icon">
                        <mat-icon class="{{checkIfSomeInGroupHasComment(group) ? 'booking-icon-active' : null}}"
                        matTooltip="{{checkIfSomeInGroupHasComment(group) ? 'Minst en bokning med en kommentar' : 'Inga kommentarer'}}">chat_bubble</mat-icon>
                      </span>
                    }
                  </div>
                </div>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (driverMode && group.bookings) {
            <app-driver-bookings-list [bookings]="group.bookings"
              [topic]="isGroupArrival(group) ? 'arrival' : 'departure'">
            </app-driver-bookings-list>
          }
          @if (!driverMode && group.bookings) {
            <div class="report-table-scroll" tabindex="0" role="region"
              aria-label="Bokningstabell på startsidan">
              <app-bookings-table [bookings]="group.bookings"
                [topic]="isGroupArrival(group) ? 'arrival' : 'departure'"
                [showCommentsColumn]="checkIfSomeInGroupHasComment(group) && !printGroups"
                [showServicesColumn]="(checkIfSomeInGroupHasCarWash(group) || checkIfSomeInGroupHasCharge(group) || checkIfSomeInGroupHasTireRepair(group)) && !printGroups"
                [showTravelHomeFromColumn]="isGroupPickedUpCustomers(group)"
                [showParkTimeColumn]="isGroupCallCustomers(group) && !printGroups">
              </app-bookings-table>
            </div>
          }
        </mat-expansion-panel>
      }
    }
  </mat-accordion>
}

@if ((!groupedBookings || groupedBookings.length < 1 || !hasVisibleGroups()) && !errorCode) {
  <div class="empty-content"
    >
    <p>Inga körningar de närmsta timmarna</p>
    <mat-icon fontIcon="coffee"></mat-icon>
  </div>
}

@if (errorCode && errorCode >= 400 && groupedBookings.length < 1) {
  <div class="error-content">
    <p>Någonting gick fel vid hämtning av bokningar. Ladda om sidan för att göra ett nytt försök.</p>
    <p>Om problemet kvarstår, kontakta Rely IT för support.</p>
  </div>
}